import React, { useState } from 'react';
import { toast } from 'react-toastify';

function Register({ onRegister }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password || !role) {
      toast.error('Barcha maydonlarni to‘ldiring.');
      return;
    }
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, role })
      });
      const data = await res.json();
      if (!res.ok) {
        toast.error(data.message || 'Ro‘yxatdan o‘tishda xatolik.');
      } else {
        toast.success('Muvaffaqiyatli ro‘yxatdan o‘tdingiz!');
        if (onRegister) onRegister(data);
      }
    } catch (err) {
      toast.error('Tarmoq xatosi.');
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <form onSubmit={handleSubmit} className="p-4 bg-white rounded shadow" style={{minWidth: 320}}>
        <h2 className="mb-4 text-center">Ro‘yxatdan o‘tish</h2>
        <div className="mb-3">
          <label className="form-label">Login</label>
          <input
            type="text"
            className="form-control"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Parol</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Rol</label>
          <select className="form-control" value={role} onChange={e => setRole(e.target.value)}>
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <button type="submit" className="btn btn-success w-100">Ro‘yxatdan o‘tish</button>
      </form>
    </div>
  );
}

export default Register; 